import { TabContainer } from "../ServicesTab/servicestab.styled";
import search from "../../assets/searchIcon.svg";
import { Header, Numbers, TableSection } from "./Tabs.styled";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
// import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { FC, ReactElement, useEffect, useState } from "react";

import { Table } from "../MoveOutTerminationTabs/MoveOut.styled";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";

interface Obj {
  [key: string]: any;
}

interface Props {
  GetConnectorAccounts: () => {};
  connectorAccounts: Obj[];
  addAccount: (a: {}) => void;
  removeAccount: (a: string) => void;
  Next: React.MouseEventHandler<HTMLButtonElement>;
  Previous: React.MouseEventHandler<HTMLButtonElement>;
  inputValue: any;
  setinputValue: any;
  connectorLoader:Boolean;
}

const ConnectionFreePlots: FC<Props> = ({
  GetConnectorAccounts,
  connectorAccounts,
  addAccount,
  removeAccount,
  Next,
  Previous,
  setinputValue,
  inputValue,
  connectorLoader
}: Props): ReactElement => {
  // State variables to keep track of selected accounts
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState<string[]>([]); // Specify the type as an array of strings
  const [connectorAccountdata,setconnectorAccountdata]=useState<any>([]);

  const handleAccountToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const index = parseInt(event.target.value);
    setinputValue(index + 1);
    if (event.target.checked) {
      addAccount(connectorAccountdata[index]);
      // Add the selected account to the list
      setSelectedAccounts((prevSelectedAccounts) => [
        ...prevSelectedAccounts,
        connectorAccountdata[index].accountId,
      ]);
    } else {
      removeAccount(connectorAccountdata[index].accountId);
      // Remove the selected account from the list
      setSelectedAccounts((prevSelectedAccounts) =>
        prevSelectedAccounts.filter(
          (accountId) => accountId !== connectorAccountdata[index].accountId
        )
      );
    }
  };

  const handleSelectAllToggle = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = event.target.checked;
    setSelectAllChecked(isChecked);

    // Update the selectedAccounts state based on isChecked
    if (isChecked) {
      setSelectedAccounts(
        connectorAccountdata?.map((account:any) => account.accountId)
      );
    } else {
      setSelectedAccounts([]);
    }

    // Call handleAccountToggle for each account when selecting all from header checkbox
    connectorAccountdata?.forEach((account:any, index:any) => {
      if (isChecked) {
        addAccount(account);
      } else {
        removeAccount(account.accountId);
      }
    });
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const toz = event.target.value;
    const initData = connectorAccountdata;
    const filteredCases =
      toz != null && toz != ""
        ? initData.filter((payment: any) => {
            const searchString = toz.toLowerCase(); // Convert the filter to lowercase for case-insensitive search
            return Object.values(payment).some((value) => {
              if (value && typeof value === "string") {
                return value.toLowerCase().includes(searchString);
              }
              return false;
            });
          })
        : initData;
    connectorAccountdata([...filteredCases]);
  };
  useEffect(() => {
    // GetServiceAccounts();
    setconnectorAccountdata(connectorAccounts)
  }, [connectorAccounts]);
  console.log("inputValue", inputValue);
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <TabContainer style={{ width: "100%", marginTop: "30px",overflow:'auto' }}>
      <Header style={{flexDirection:General?.isLargeScreen?'row':'column',width:General?.isLargeScreen?'':"100%",marginTop:General?.isLargeScreen?'':'3rem'}}>
        <div
          style={{
            marginBottom: "20px",width:General?.isLargeScreen?"":"100%"
          }}
        >
          <span
            style={{
              fontSize: `${1.5 * General.accessibility.fontSize}rem`,
              fontWeight: "700",
              fontStyle: "normal",
              lineHeight: "32px",
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              marginTop:General?.isLargeScreen?'':'2rem'
            }}
          >
            {General?.codeLabels["cm_pdc_heading"]?.label? General?.codeLabels["cm_pdc_heading"]?.label: "Connection-Free Connected Plots"}
          </span>
          <span
            style={{
              fontSize: `${0.875 * General.accessibility.fontSize}rem`,
              fontStyle: "normal",
              lineHeight: "14px",
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              marginTop:General?.isLargeScreen?'':'1rem'
            }}
          >
            {General?.codeLabels["cm_plan_detail_service"]?.label?General?.codeLabels["cm_plan_detail_service"]?.label:'Add Plots from the list below to create the payment plan request'}
          </span>
        </div>
        <div style={{width:General?.isLargeScreen?"":"100%",marginTop:General?.isLargeScreen?'':'1rem'}}>
          <input
          onChange={handleSearchChange}
            style={{
              width:General?.isLargeScreen? "274px":"100%",
              height: "38px",
              fontSize: `${0.875 * General.accessibility.fontSize}rem`,
              paddingLeft: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '40px' : '10px',
              paddingRight: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '10px' : '40px',
              position: "relative",
              color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss,
              backgroundColor: contrast?.contrastColor ? contrast?.contrastColor : "",
            }}
            type="text"
            placeholder={General?.codeLabels["cm_search"]?.label?General?.codeLabels["cm_search"]?.label:'Search'}
          />
           <span style={{
            paddingRight: "10px",
            width: "2vw",
            height: "3vh",
            display: "flex",
            alignItems: "center",
            marginLeft: '20px',
            position:"absolute"
          }}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6273 7.14735C13.6273 3.57556 10.7187 0.666992 7.14694 0.666992C3.57515 0.666992 0.666584 3.57556 0.666584 7.14735C0.666584 10.7191 3.57515 13.6277 7.14694 13.6277C8.69868 13.6277 10.1213 13.0835 11.2377 12.1696L16.4017 17.3337L17.3333 16.4021L12.1692 11.2381C13.083 10.1217 13.6273 8.69909 13.6273 7.14735ZM1.96266 7.14735C1.96266 4.27675 4.27635 1.96306 7.14694 1.96306C10.0175 1.96306 12.3312 4.27675 12.3312 7.14735C12.3312 10.0179 10.0175 12.3316 7.14694 12.3316C4.27635 12.3316 1.96266 10.0179 1.96266 7.14735Z" fill={contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss} />
            </svg>

          </span>
        </div>
      </Header>
      {connectorLoader?<Spinner/>:<>
      <div style={{width:General?.isLargeScreen?"":"100%",overflow:"auto"}}>
      <Table  style={{marginTop:General?.isLargeScreen?'':'4rem',overflow:'auto'}} lastChild={true} beforeLastChild={true}>
        <thead>
          <tr
            style={{
              background: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "",
            }}
          >
            <th
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : "",
              }}
            >
              <input
                type="checkbox"
                style={{
                  marginInlineEnd: "15px",
                }}
              />
              <span
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
                {General?.codeLabels["cm_dpremisedetails"]?.label !== undefined
                  ? General?.codeLabels["cm_dpremisedetails"]?.label
                  : "Premise Details"}
              </span>
            </th>
            <th
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : "",
              }}
            >
               <span
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
              {General?.codeLabels["cm_accountnopaymentstable"]?.label !==
              undefined
                ? General?.codeLabels["cm_accountnopaymentstable"]?.label
                : "Account Number"}
                </span>
            </th>
            <th
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : "",
              }}
            >
               <span
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
              {General?.codeLabels["cm_seweragenum"]?.label !== undefined
                ? General?.codeLabels["cm_seweragenum"]?.label
                : "Sewerage Number"}
                  </span>
            </th>
            <th
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : "",
              }}
            >
               <span
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
              {General?.codeLabels["cm_dpremiseusage"]?.label !== undefined
                ? General?.codeLabels["cm_dpremiseusage"]?.label
                : "Premise Usage"}
                </span>
            </th>
            <th
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : "",
              }}
            >
               <span
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                }}
              >
              {General?.codeLabels["cm_amt_due"]?.label !== undefined
                ? General?.codeLabels["cm_amt_due"]?.label
                : "Amount Due"}{General?.codeLabels['cm_mob_aed']?.label?General?.codeLabels['cm_mob_aed']?.label:"AED"}
                </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {connectorAccountdata?.length > 0 ? (
            connectorAccountdata?.map((row: Obj, index: number) => {
              return (
                <tr
                  style={{
                    backgroundColor: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "",
                  }}
                >
                  <td
                    style={{
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                  >
                    <input
                      type="checkbox"
                      value={index}
                      onChange={handleAccountToggle}
                    />
                    {row.premiseAddress}
                  </td>
                  <td
                    style={{
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        :ColorAss,
                    }}
                  >
                    {row.accountId}
                  </td>
                  <td
                    style={{
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        :ColorAss,
                    }}
                  >
                    {row.premiseId}
                  </td>
                  <td
                    style={{
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                    }}
                  >
                    {row.propertyUsage}
                  </td>
                  <td
                    style={{
                      fontSize: `${General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : ColorAss,
                    }}
                  >
                    {row.currentBalance /*row.serviceFee+row.vatCharges*/}
                  </td>
                </tr>
              );
            })
          ) : (
            <p
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              {General?.codeLabels["cn_no_data"]?.label?General?.codeLabels["cn_no_data"]?.label:'No Data No Data Available'}
            </p>
          )}
        </tbody>
      </Table>
      </div>

      <hr style={{ width: "100%", marginBottom: "20px" }} />
      <div
        style={{
          display: "flex",
          gap: "20px",
        }}
      >
        <ButtonSecondary
          style={{
            padding: "auto",
            fontSize: `${General.accessibility.fontSize}rem`,
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : ColorAss,
            background: contrast?.contrastColor ? contrast?.contrastColor : "",
            borderColor:contrast?.contrastBackground
            ? contrast?.contrastBackground
            : ColorAss,
          }}
          onClick={Previous}
        >
          {General?.codeLabels["cm_back"]?.label !== undefined
            ? General?.codeLabels["cm_back"]?.label
            : "BACK"}
        </ButtonSecondary>
        <ButtonSecondary
          style={{
            padding: "auto",
            fontSize: `${General.accessibility.fontSize}rem`,
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "#fff",
            background: contrast?.contrastColor
              ? contrast?.contrastColor
              : ColorAss,
              border:"none"
          }}
          disabled={!inputValue}
          onClick={Next}
        >
          {General?.codeLabels["cm_btncontinue"]?.label !== undefined
            ? General?.codeLabels["cm_btncontinue"]?.label
            : "CONTINUE"}
        </ButtonSecondary>
      </div>
      </>}
    </TabContainer>
  );
};

export default observer(ConnectionFreePlots);
